import { Component } from '@angular/core';

@Component({
  selector: 'app-browser-problem-link',
  templateUrl: './browser-problem-link.component.html',
  styleUrls: ['./browser-problem-link.component.scss'],
  standalone: false
})
export class BrowserProblemLinkComponent {
}
